import { createSlotRecipe } from './runtime';

const numberInputConfig = {"name":"numberInput","slots":["root","label","input","control","valueText","incrementTrigger","decrementTrigger","scrubber"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","xl"]}}

export const numberInput = /* @__PURE__ */ createSlotRecipe(numberInputConfig)